import { render, staticRenderFns } from "./AiIosBookGoods.vue?vue&type=template&id=280a934c&scoped=true"
import script from "./AiIosBookGoods.vue?vue&type=script&lang=js"
export * from "./AiIosBookGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280a934c",
  null
  
)

export default component.exports